
const AyudaEuropa = () => {

    return (
        <>
            <div className="container marginB-600 pB-600">
                <div className="mb-4 bg-white row justify-content-center">
                    <img src="/images/web/magno/ayuda-europa.png" style={{ maxWidth: "800px" }} />
                </div>
            </div>
        </>
    );
}
export default AyudaEuropa;
